import React from 'react';
import logoAzul from '../../assets/branding/lbcc-azul.png';
import logoBranco from '../../assets/branding/lbcc-branco.png';

const variantMap = {
  dark: {
    logo: logoBranco,
    titleClass: 'text-white',
    subtitleClass: 'text-slate-400',
  },
  light: {
    logo: logoAzul,
    titleClass: 'text-slate-900',
    subtitleClass: 'text-slate-500',
  },
};

export default function BrandLockup({
  surface = 'dark',
  compact = false,
  centered = false,
  title = 'LBCCorex HUB',
  subtitle = 'Inteligência que move negócios',
  showSubtitle = true,
  logoClassName = '',
  className = '',
  dataTestId = 'brand-lockup',
}) {
  const variant = variantMap[surface] || variantMap.dark;
  const layoutClass = compact
    ? 'flex items-center gap-3'
    : centered
      ? 'flex flex-col items-center text-center gap-4'
      : 'flex items-center gap-4';

  return (
    <div className={`${layoutClass} ${className}`.trim()} data-testid={dataTestId}>
      <img
        src={variant.logo}
        alt="LBCC"
        className={`h-14 w-14 object-contain ${compact ? 'shrink-0' : 'h-20 w-20'} ${logoClassName}`.trim()}
        data-testid={`${dataTestId}-image`}
      />
      <div className={centered && !compact ? 'space-y-1' : 'min-w-0'}>
        <h1 className={`font-bold leading-none ${compact ? 'text-base sm:text-lg' : 'text-4xl'} ${variant.titleClass}`.trim()}>
          {title}
        </h1>
        {showSubtitle ? (
          <p className={`mt-1 text-sm ${variant.subtitleClass}`.trim()} data-testid={`${dataTestId}-subtitle`}>
            {subtitle}
          </p>
        ) : null}
      </div>
    </div>
  );
}